<template>
  <!-- 版本审核 -->
  <div class="page">
    <!-- 表格 -->
    <DiluTable :list="tableData" :tableConfig="tableConfig">
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope"
          ><span>{{ scope.$index + 1 }}</span></template
        >
      </el-table-column>
      <el-table-column prop="version" :label="$t('pages.system.text1')"  align="center">
      </el-table-column>
      <el-table-column prop="fileName" :label="$t('pages.system.text4')" width="200" align="center">
      </el-table-column>
      <el-table-column prop="fileSize" :label="$t('pages.system.text5')" align="center">
        <template slot-scope="scope">
          <span>{{ sizeReset(scope.row.fileSize) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdBy" :label="$t('pages.system.text13')" align="center">
      </el-table-column>
      <el-table-column prop="recentlyAt" :label="$t('pages.system.text3')" align="center">
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['versionReview:see']"
              >{{$t('button.look')}}</el-button
            >
            <el-button
              @click="toExamine(scope.row)"
              type="text"
              v-permission="['versionReview:toExamine']"
              >{{$t('button.examine')}}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 审核弹窗 -->
    <VersionToExamine
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      :lookUpData="lookUpData"
      @versionReviewReviewList="versionReviewReviewList"
    />

    <!-- 查看弹窗 -->
    <VersionManagementLookUp
      :lookUpVisible="lookUpVisible"
      @lookUpClose="lookUpClose"
      :lookUpData="lookUpData"
    />
  </div>
</template>

<script>
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import VersionToExamine from "./module/versionToExamine.vue";
import VersionManagementLookUp from "./module/versionManagementLookUp.vue";
import { mapState } from "vuex";
import { sizeReset } from "../../../utils/util/validate";
export default {
  data() {
    return {
      lookUpData: {},
      lookUpVisible: false, //查看弹窗
      dialogVisible: false, //审核弹窗
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      tableData: [],
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluTable,
    VersionToExamine,
    VersionManagementLookUp,
  },
  mounted() {
    this.versionReviewReviewList();
  },
  methods: {
    sizeReset(e) {
      return sizeReset(e);
    },
    //关闭查看弹窗
    lookUpClose() {
      this.lookUpVisible = false;
    },
    //查看
    see(e) {
      this.lookUpData = e;
      this.lookUpVisible = true;
    },
    //关闭审核弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //审核
    toExamine(e) {
      this.lookUpData = e;
      this.dialogVisible = true;
    },
    //查询所有待审核app版本
    versionReviewReviewList() {
      this.request
        .versionReviewReviewList({ appCode: this.platformData.appCode })
        .then((res) => {
          this.tableData = res.data;
        });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>